import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import appLogo from "./img/renna-logo.png";
import ReactGA from "react-ga4";

function NavBar() {
  const [isOpen, setIsOpen] = useState(false);

  const closeSideNav = () => {
    setIsOpen(false);
  };

  const openSideBar = () => {
    setIsOpen(true);
  };

  const handleClick = (section) => {
		ReactGA.event({
		  category: 'MenuLink',
		  action: 'Click',
		  label: `${section}`,
	    });
 };


  return (
    <nav className="navbar">
      <div className="hamburger" onClick={openSideBar}>
        <div className="hamburger-bar"></div>
        <div className="hamburger-bar"></div>
        <div className="hamburger-bar"></div>
      </div>
      <div className="nav-image">
        <Link to="/"><img src={appLogo} width="100px" height="50" alt="Logo" /></Link>
      </div>
      <div
        className={`backdrop ${isOpen ? "open" : ""}`}
        onClick={closeSideNav}
      ></div>
      <ul className="navbar-items">
        <li className="nav-item">
          <Link to="/" className="nav-link">
            Home
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/#promotions" className="nav-link" onClick={() => handleClick("promotions")}>
            Promotions
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/#popular-plans" className="nav-link" onClick={() => handleClick("popular-plans")}>
            Popular Plans
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/#services" className="nav-link" onClick={() => handleClick("services")}>
            Services
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/sim-tariff" className="nav-link">
            SIM Tariffs
          </Link>
        </li>
        <li className="nav-item">
          <Link to="/#benefits" className="nav-link" onClick={() => handleClick("benefits")}>
            Benefits
          </Link>
        </li>
      </ul>
      <div className="menu-btn">
        <a
          href="https://recharge.rennamobile.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <button className="menu-button" onClick={() => handleClick("recharge")} >Recharge</button>
        </a>
      </div>
      <div className={`side-nav ${isOpen ? "open" : ""}`}>
        <ul>
          <li onClick={closeSideNav}>
            <Link to="/" className="nav-link">
              Home
            </Link>
          </li>
          <li onClick={closeSideNav}>
            <Link to="/#promotions" className="nav-link" onClick={() => handleClick("promotions")}>
              Promotions
            </Link>
          </li>
          <li onClick={closeSideNav}>
            <Link to="/#popular-plans" className="nav-link" onClick={() => handleClick("popular-plans")}>
              Popular Plans
            </Link>
          </li>
          <li onClick={closeSideNav}>
            <Link to="/#services" className="nav-link" onClick={() => handleClick("services")}>
              Services
            </Link>
          </li>
          <li onClick={closeSideNav}>
            <Link to="/sim-tariff" className="nav-link">
              SIM Tariffs
            </Link>
          </li>
          <li onClick={closeSideNav}>
            <Link to="/#benefits" className="nav-link" onClick={() => handleClick("benefits")}>
              Benefits
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  );
}
export default NavBar;
